import {
  useDataLoader,
  AssetPurchasePeriodTypeService,
} from "@xala/common-services";
import { NotificationService } from "@xala/common-ui";
import { useTranslation } from "react-i18next";

const notificationService = NotificationService.getInstance();
const assetService = new AssetPurchasePeriodTypeService().promisify();

export const useAssetPurchasePeriodTypeDataProvider = () => {
  const { t } = useTranslation();
  const { data, loading } = useDataLoader({
    loader: () => assetService.select(),
    onError: (error) =>
      notificationService.error({
        message: error.Title,
        description: error.Message,
      }),
    debounce: 500,
    deps: [],
  });
  return {
    purchasePeriodTypes:
      data?.map((asset) => ({
        key: asset.Code,
        value: asset.Code,
        label: asset.DisplayName,
      })) || [],
    loading,
  };
};
